import { render, staticRenderFns } from "./whoweare.vue?vue&type=template&id=4b3b1865&scoped=true&"
var script = {}
import style0 from "./whoweare.vue?vue&type=style&index=0&id=4b3b1865&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3b1865",
  null
  
)

export default component.exports